import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useCart } from '../commerce/CartContext';
import { logoUrl } from '../data';

const {
  FiMenu,
  FiX,
  FiSearch,
  FiUser,
  FiShoppingBag
} = FiIcons;

const links = [
  ['Home', 'home'],
  ['Collection', 'collection'],
  ['About', 'about'],
  ['Contact', 'contact']
];

function Header() {
  const [open, setOpen] = useState(false);
  const { itemCount, setDrawerOpen } = useCart();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.toggle('menu-open', open);

    return () => document.body.classList.remove('menu-open');
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const visitSection = (sectionId) => {
    setOpen(false);

    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }

    navigate('/', { state: { scrollTo: sectionId } });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;

    if (location.pathname === '/' && sectionId) {
      window.requestAnimationFrame(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location]);

  return (
    <header className="site-header">
      <div className="header-inner">
        <button
          className="mobile-control"
          onClick={() => setOpen(!open)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
        >
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>

        <Link className="brand" to="/" aria-label="ZEVI home">
          <img src={logoUrl} alt="ZEVI" />
        </Link>

        <nav
          className={`main-nav ${open ? 'open' : ''}`}
          aria-label="Main navigation"
        >
          {links.map(([label, sectionId]) => (
            <button
              className="nav-section-button"
              key={label}
              onClick={() => visitSection(sectionId)}
            >
              {label}
            </button>
          ))}
          <Link to="/shop" onClick={() => setOpen(false)}>Shop</Link>
          <Link className="menu-order" to="/cart" onClick={() => setOpen(false)}>
            My Cart
          </Link>
          <Link className="menu-secondary-link" to="/checkout">
            Checkout
          </Link>
          <Link className="menu-secondary-link" to="/order-tracking">
            Order Tracking
          </Link>
        </nav>

        <div className="header-actions">
          <Link
            className="header-icon-link"
            to="/shop"
            aria-label="Search the collection"
          >
            <SafeIcon icon={FiSearch} />
          </Link>
          <Link
            className="header-icon-link account-link"
            to="/order-tracking"
            aria-label="Order tracking"
          >
            <SafeIcon icon={FiUser} />
          </Link>
          <button
            className="cart-trigger"
            onClick={() => setDrawerOpen(true)}
            aria-label={`Open cart with ${itemCount} items`}
          >
            <SafeIcon icon={FiShoppingBag} />
            {itemCount > 0 && (
              <span className="cart-badge">{itemCount}</span>
            )}
          </button>
          <Link className="outline-button desktop-shop" to="/shop">
            Shop now
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;